import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { AppContext } from "../../App";


export default function SingleCard(props){

  const bandDocs = props.bandInfo.bandDocuments

  console.log(bandDocs)

  const docObj = bandDocs.find(o => o.docName === props.name)

  return (
    <Card elevation={2}>
      <Typography sx={{marginTop:'1em', mb: 1.5, marginLeft:'1em', marginRight: '1em' }} color="text.secondary">
        {props.title}
      </Typography>
      {props.icon}
      <CardActions>
        <a href={docObj.docURL} target="_blank" className="press-cards" >
          <Button disabled={docObj.docURL === ''} onClick={()=> console.log("button clicked")} sx={{fontSize:'0.8em'}} size="small">Download</Button>
        </a>
      </CardActions>
    </Card>
  )}